import axios from '@/allotment/axios'

export default {
  deviceDelete: id => axios.get(`/device/deal/delete/${id}`), //删除设备日志
  devicePage: data => axios.post('/device/deal/select/page', data), //获取设备日志

  delete: id => axios.get(`/oplog/delete/${id}`), //删除操作日志
  operatePage: data => axios.post('/oplog/select/page', data) //获取操作日志
}